import { Transport } from './transport/xhrTransport'
import { ITranslations } from '@/interfaces/translations'
import Vue from 'vue'
import config from '@/config'
class StaticTranslationsQuery extends Transport {
  constructor() {
    super({
      origin: 'web',
      apiMethod: 'Translation/GetStaticTranslations'
    })
  }
  public onAfterReceive(result) {
    for (const key of Object.keys(result)) {
      Vue.set(translations, key, result[key])
    }
    config.langId = result.System.LangId as string
    config.culture = result.System['Locale code'] as string
  }
}
const transport = new StaticTranslationsQuery()
const translations: ITranslations = Vue.observable({
  Betslip: {},
  Buttons: {},
  Common: {},
  Headers: {},
  Labels: {},
  Messages: {},
  Other: {},
  PrintOdds: {},
  System: {},
  Virtuals: {},
  'Frontend type': {}
})
export function fetch() {
  return transport.fetch()
}
export default translations
